import { useMemo, useState } from 'react'
import { Box, Text, VStack } from '@chakra-ui/react'

import { withPage } from '@/features/layout'
import { FilterPeriod } from '@/features/domains/Consents/types'
import { PeriodFilter } from '@/features/domains/Consents/components'
import { AdminProjectChart } from '../../containers'

type Project = {
  id: number
  url: string
}

type Props = {
  projects: Project[]
}

function AdminCompanyConsentPage({ projects }: Props) {
  const [filterPeriod, setFilterPeriod] = useState<FilterPeriod>('this_month')
  const [customPeriod, setCustomPeriod] = useState<string>('')

  const charts = useMemo(() => {
    return projects.map((project) => (
      <VStack key={`project-chart-${project.id}`} gap={1} width="full">
        <Text>{project.url}</Text>
        <AdminProjectChart
          filterPeriod={filterPeriod}
          customPeriod={customPeriod}
          project={project}
        />
      </VStack>
    ))
  }, [projects, filterPeriod, customPeriod])

  return (
    <Box
      sx={{
        py: 6,
        px: 8,
        position: 'relative',
        width: 'full',
        maxW: '1440px',
        mx: 'auto !important',
      }}
    >
      <VStack
        sx={{
          py: 6,
          px: 8,
          gap: '32px',
          alignItems: 'flex-start',
          width: 'full',
          bgColor: 'white',
          borderRadius: '16px',
        }}
      >
        <PeriodFilter
          setPeriod={setFilterPeriod}
          customPeriod={customPeriod}
          setCustomPeriod={setCustomPeriod}
        />

        {charts}
      </VStack>
    </Box>
  )
}

export default withPage(AdminCompanyConsentPage)
